"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTransfer = function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 19"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.237 7H0m6-4 3.145 4.033-2.582 3.438M19.89 1.404c.604.54.984.879 1.138 1.019.86.766 1 1.85.417 3.25-.874 2.102-4.151 7.17-11.288 11.453-1.575 1.108-2.99.858-3.64 0a88.727 88.727 0 0 0-1.273-1.643c-.462-.714-.268-1.376.583-1.987 1.277-.917.87-.594 1.912-1.309 1.043-.715 1.034-.555 2.418 0 1.383.556 1.396 1.04 2.767-.269.914-.872 2.084-2.064 3.512-3.575.536-.504.536-1.132 0-1.884-.803-1.129-.803-1.563 0-2.8a23.43 23.43 0 0 1 1.654-2.255c.595-.539 1.195-.539 1.8 0z",
    fill: "none",
    stroke: "#FFF"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTransfer);
var _default = exports["default"] = Memo;